export const agentPlayground = {
  header: {
    title: "KI-Agent testen",
    chip: "KI-Rezeption · Beta",
    sub: "Chatten Sie mit dem erweiterten Agenten, ohne etwas über WhatsApp zu senden.",
  },
  context: {
    title: "Kontext",
    listingLabel: "Inserat",
    listingPlaceholder: "Inserat auswählen…",
    allListings: "🌐 Alle Unterkünfte (neue Buchungen)",
    accountModeHint:
      "Der Agent antwortet, als wäre er nicht an eine bestimmte Unterkunft gebunden: ideal, um Buchungsanfragen zu testen.",
    guestStatusLabel: "Gaststatus",
    stay: {
      auto: "Automatisch",
      inStay: "Derzeit vor Ort (während des Aufenthalts)",
      beforeArrival: "Noch nicht angereist (zukünftige Buchung)",
      after: "Aufenthalt beendet",
    },
    guestStatusHint: "Simulieren Sie den Moment des Gastes, um die unterschiedlichen Antworten zu sehen.",
    reservationIdLabel: "Buchungs-ID",
    optional: "(optional)",
    reservationIdPlaceholder: "z. B. 1234",
    phoneLabel: "Telefon des Gastes",
    phonePlaceholder: "+34...",
    langLabel: "Sprache",
    lang: {
      auto: "Automatisch",
      es: "Spanisch",
      en: "Englisch",
      pt: "Portugiesisch",
      fr: "Französisch",
      de: "Deutsch",
      pl: "Polnisch",
    },
    reset: "Unterhaltung zurücksetzen",
  },
  debug: {
    resolvedTitle: "Aufgelöster Kontext",
    listing: "Inserat",
    property: "Unterkunft",
    reservation: "Buchung",
    checkin: "Check-in",
    checkout: "Check-out",
    lang: "Sprache",
    toolsTitle: "Verwendete Tools",
  },
  chat: {
    emptyPrompt: "Schreiben Sie eine Nachricht, als wären Sie der Gast.",
    pay: "Bezahlen",
    book: "Buchen",
    sentAsButton: "Auf WhatsApp wird es als Button gesendet",
    sentAsList: "Auf WhatsApp wird es als Liste gesendet · {button}",
    inputPlaceholder: "Nachricht schreiben…",
  },
  suggestions: {
    s1: "Wann ist der Check-in?",
    s2: "Gibt es Parkplätze?",
    s3: "Haben Sie WLAN? Wie lautet das Passwort?",
    s4: "Kann ich früher einchecken?",
  },
  errors: {
    loadListings: "Die Inserate konnten nicht geladen werden.",
    chatError: "Fehler bei der Kommunikation mit dem Agenten.",
    chatReplyFallback: "⚠️ Ich konnte nicht antworten. Prüfen Sie den Kontext oder versuchen Sie es erneut.",
  },
  methods: {
    listingFallback: "Inserat #{id}",
  },
};
